<template>
  <modal-base @clickOverlay="close" class="delete-account-modal">
    <div class="delete-account-modal__body">
      <div class="delete-account-modal__title">
        <red-text class="red-text">I’m</red-text> sorry...
      </div>

      <div class="delete-account-modal__wrap">
        <div class="delete-account-modal__description">
          Hope you’ll be back again soon.
          <br />
          <br />
          Do you still want to receive<br/>
          Weekly summaries to your email?
        </div>
        <div class="delete-account-modal__drone"></div>
        <checkbox-el id="delete-checkbox" v-model="keepEmailSubscription"  class="delete-account-modal__checkbox">Yes I want to receive emails</checkbox-el>
        <div class="buttons">
          <button-el @click="deleteAccount" class="delete-btn" :disabled="requestInProgress">Delete<span class="delete-btn__full-text"> account</span></button-el>
          <button-el @click="close" red class="stay-btn" :disabled="requestInProgress">Stay</button-el>
        </div>
      </div>
    </div>
  </modal-base>
</template>

<script>
import { mapActions } from 'vuex';
import ModalBase from 'Common/ModalBase';

export default {
  data: () => ({
    keepEmailSubscription: true,
    requestInProgress: false,
  }),
  components: {
    ModalBase,
  },
  methods: {
    ...mapActions('userData', [
      'logOut',
    ]),
    deleteAccount() {
      this.requestInProgress = true;
      this.$apiService.deleteAccount(this.keepEmailSubscription).then(() => {
        this.logOut();
      }).catch(() => {
        this.requestInProgress = false;
      });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  $max-width: 380px;
  $padding-side: 30px;
  .delete-account-modal {
    &__title {
      @include font(24px, $black-color1, 500);
      margin-top: 5px;
      border-bottom: 1px solid $white-color5;
      padding: 27px $padding-side 25px;
    }
    &__body {
      width: $max-width;
      max-width: 100%;
      margin: auto;
      background: $white-color2;
      position: relative;
      z-index: 2;
    }
    &__wrap {
      padding: 28px $padding-side;
    }
    &__description {
      max-width: 243px;
      line-height: 21px;
    }
    &__drone {
      @include attachImage('drone-down', 112px, 112px);
      position: absolute;
      right: 19px;
      top: 81px;
    }
    &__checkbox {
      margin-top: 27px;
      margin-bottom: 41px;
    }
  }
  .red-text {
    display: inline-block;
  }
  .stay-btn {
    margin-left: 16px;
  }
  $bp: $max-width + ($modal-side-margin * 2) - 1px;
  @media screen and (max-width: $bp) {
    .delete-btn__full-text {
      display: none;
    }
    .btn {
      width: 110px;
    }
    .stay-btn {
      margin-left: 20px;
    }
    .buttons {
      display: flex;
      justify-content: center;
    }
  }
  @media screen and (max-width: 375px) {
    .delete-account-modal {
      &__drone {
        margin-top: -9px;
        margin-right: -59px;
      }
      &__wrap {
        padding-right: 0;
      }
    }
    .buttons {
      margin-left: -$padding-side;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/settings/DeleteAccountModal.vue